import {
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
/**
 * @module InvoicePurchaseSkeleton
 */

/**
 * @param {Object} props
 * @param {number} props.columns
 * @param {number} props.rows
 * @returns {JSX.Element}
 */
const InvoicePurchaseSkeleton = ({ columns, rows }) => {
  return (
    <Paper sx={{ bgcolor: '#efefef' }}>
      <Stack direction={'row'} justifyContent={'flex-end'} spacing={2}>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={90}
          height={25}
          sx={{
            alignSelf: 'flex-end',
          }}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={90}
          height={25}
          sx={{
            alignSelf: 'flex-end',
          }}
        />
      </Stack>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: '70vh',
        }}
      >
        <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ p: 2 }} component="th" scope="row">
                <Skeleton animation="wave" variant="text" />
              </TableCell>
              {[...Array(columns - 1)].map((i, index) => (
                <TableCell key={index} sx={{ p: 2 }}>
                  <Skeleton fontSize={'.9em'} animation="wave" variant="text" />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(rows)].map((i, index) => (
              <TableRow key={index}>
                <TableCell sx={{ p: 2 }} component="th" scope="row">
                  <Skeleton animation="wave" variant="text" />
                </TableCell>
                {[...Array(columns - 1)].map((i, index) => (
                  <TableCell key={index} sx={{ p: 2 }}>
                    <Skeleton fontSize={'.9em'} animation="wave" variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}

export default InvoicePurchaseSkeleton
